<template>
    <div class="aboutStyle">
        <span class="line"></span>
        <span class="doint"></span>
        <span class="title">{{title}}</span>
        <span class="doint"></span>
        <span class="line"></span>
    </div>
</template>
<script>
    export default {
        name: 'aboutStyle',
        props: {
            title: {
                type: String,
                default: '关于我们'
            }
        },
        data() {
            return {}
        }
    }
</script>
<style lang="less" scoped>
    .aboutStyle {
        text-align: center;

        .line {
            width: 50px;
            border-top: 1px solid #bbb;
            display: inline-block;
            position: relative;
            top: -3px;
        }

        .doint {
            width: 8px;
            height: 8px;
            display: inline-block;
            border-radius: 50%;
            background: #bbb;
        }

        .title {
            margin: 0 15px;
            font-size: 24px;
        }
    }
</style>